import { useCallback, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import User from "../services/user";
import { useGetDomain, useGetUser } from "../common/Hooks";
import GuestView from "../components/guest/GuestView";
import Icon from "../components/controls/Icon";

const GuestHome = () => {
    const [translate] = useTranslation();
    const [initialized, setInitialized] = useState(false);
    const [, setDomain] = useGetDomain();
    const [user, setUser] = useGetUser({});

    const initialize = useCallback(async (user) => {
        if (!user._id) {
            const userDetails = await User.getUser();
            if (userDetails && !userDetails.error) {
                const loggedUser = userDetails.data;
                setDomain({
                    _id: loggedUser.domain[0]._id,
                    name: loggedUser.domain[0].name,
                });

                window.sessionStorage.setItem(
                    "root-domain",
                    loggedUser.domain[0].rootDomain || false
                );

                setUser({
                    _id: loggedUser._id,
                    email: loggedUser.email,
                    appAdmin: loggedUser.appAdmin,
                    firstName: loggedUser.firstName,
                    lastName: loggedUser.lastName,
                    adminForDomains: loggedUser.adminForDomains,
                    uiPermissions: loggedUser.uiPermissions,
                    singleDomainUser: loggedUser.singleDomainUser,
                    isGuest: loggedUser.isGuest
                });
                setInitialized(true);
            }
        } else {
            setInitialized(true);
        }
    }, [setDomain, setUser, setInitialized]);

    useEffect(() => {
        if (!initialized) {
            initialize(user);
        }
    }, [initialize, initialized, user]);

    if (!initialized) {
        return <div className="bg-white h-100"></div>
    }

    return (
        <>
            <header className="fixed-top navbar navbar-expand-lg navbar-dark bg-secondary">
                <div className="navbar-brand" >
                    <img src="/logo.svg" className="logo" alt="Cœptis - by OnTheMove" />
                </div>
                <div className="collapse navbar-collapse">
                    <div className="navbar-text mx-auto h4 p-0 text-white">{translate("OTM_FORMS_GUEST_HEADER")}</div>
                    <div className="navbar-nav">
                        <button className="btn nav-link border-0 ms-2 p-0 bg-transparent" onClick={() => window.open(process.env.REACT_APP_FORMS_WEBSITE)}>
                            <Icon icon="Language" className="d-block" />
                        </button>
                    </div>
                </div>
            </header>
            <main id="main" className="container-fluid flex-grow-1 d-flex flex-column overflow-auto bg-light">
                <GuestView />
            </main >
        </>
    );
}

export default GuestHome;